module.exports = __webpack_public_path__ + "media/images/icons/icon_twitter-751a2a6d18972c59fcc1e7d8058da71a.svg";